exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".paginator[data-v-5de271ae]{width:100%;min-width:300px;position:absolute;left:0;bottom:10px;text-align:center;margin:0 auto}.paginator .arrow[data-v-5de271ae]{display:inline-block;position:absolute;vertical-align:top;height:20px;width:20px;margin:18px 10px 0;cursor:pointer}.paginator .arrow.left[data-v-5de271ae]{left:calc(50% - 170px)}.paginator .arrow.right[data-v-5de271ae]{right:calc(50% - 170px)}.paginator .thumbnail-wrapper[data-v-5de271ae]{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5de271ae","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./assets/vue/components/images/components/paginator.styl
// module id = 553
// module chunks = 0